import BeniftContent from "./BeniftContent";
import { SectionHeader } from '@apps/components/section-header';
import React from 'react';

const Benifits = ({title, subTitle, benefitsData}) => {
  return (
    <>
      {/* <!-- Benefits --> */}
      <section className="py-24 dark:bg-jacarta-900">
        <div className="container">
          <SectionHeader title={title} subTitle={subTitle} containerClass={"mx-auto mb-20 text-center"}/>
          <BeniftContent benefitsData={benefitsData}/>
        </div>
      </section>
      {/* <!-- end benefits --> */}
    </>
  );
};

export default Benifits;
